import React from "react";
import { renderToString } from "react-dom/server";
import { SpinnerCircular } from 'spinners-react'

export const loading = {
    runLoadingBlockUI,
    stopRunLoading,
};

function runLoadingBlockUI() {
    ($ as any).blockUI({
        css: {
            border: "none",
            padding: "15px",
            backgroundColor: 0,
            "-webkit-border-radius": "10px",
            "-moz-border-radius": "10px",
            opacity: 1,
            color: "#fff",
        },
        message: renderToHtmlCode(),
    });
}

function stopRunLoading() {
    ($ as any).unblockUI();
}

const renderToHtmlCode = () => {
    return renderToString(
        <SpinnerCircular size={68} thickness={116} speed={163} color="rgba(121, 217, 255, 1)" secondaryColor="rgba(121, 217, 255, 0.31)" />
    );
};
